








































import { CommonField } from '@ssp/inscreva-sse-models';
import { Component, Vue, Prop } from 'vue-property-decorator';

import { stringFormatter } from '../models/utils';

@Component
export default class FieldRegistrationComponent extends Vue {
  @Prop()
  isChild?: boolean;

  @Prop({ required: true })
  field!: CommonField;

  onChangeFieldName(input: InputEvent) {
    const { value } = input.target as HTMLInputElement;
    this.field.name = stringFormatter(value, true, false).replace(/\s+/g, '_').trim();
    this.field.text = value;
    this.field.id = this.field.type === 'field' ? this.field.name : this.field.id;
  }

  get is_option(): boolean {
    return this.field.type === 'option';
  }

  get has_options(): boolean {
    return !!this.field.options;
  }

  get placeholder(): string {
    return (
      (this.isChild && 'Ex: Ensino Médio') ||
      (this.has_options && 'Ex: Grau de Escolaridade') ||
      'Ex: Número de Registro'
    );
  }

  get field_name(): string {
    return this.is_option ? 'Opção' : 'Nome';
  }
}
